import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { PublicTopicsComponent } from './topics/public-topics.component';
import {LandingPageComponent} from 'app/public-pages/landing/landing.component';

@NgModule({
  imports: [SharedModule],
  declarations: [LandingPageComponent, PublicTopicsComponent],
  exports: [LandingPageComponent, PublicTopicsComponent]
})
export class PublicPagesModule {}
